// All Files

import rethinkBiocleanLogo1 from "assets/images/rethink_bioclean/logos/logo_1.png";
import rethinkBiocleanTruck1 from "assets/images/rethink_bioclean/backgrounds/truck.png";

const FILES = { rethinkBiocleanLogo1, rethinkBiocleanTruck1 };

export default FILES;
